var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title mb-3"},[_vm._v("MAPPA MOVIMENTO")]),_c('b-table',{staticClass:"figbHeader",attrs:{"fields":_vm.fieldsToBeShown,"items":_vm.formattedRoundMap,"sort-by":"round"},scopedSlots:_vm._u([{key:"cell(vs)",fn:function(data){return [_c('span',{domProps:{"innerHTML":_vm._s(data.value)}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }